export class CreateCredentialsProfileInputGcp {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "targetServiceAccountEmail",
            "baseName": "targetServiceAccountEmail",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateCredentialsProfileInputGcp.attributeTypeMap;
    }
    constructor() {
    }
}
